<template>
  <div class="footer">
    <div v-for="( item  , index ) in imgUrl" :key="index">
      <img :src="item" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name:"MainFooter",
  data(){
    return{
      imgUrl:[
        require('@/assets/image/图标1.png'),
        require('@/assets/image/图标2.png'),
        require('@/assets/image/图标3.png'),
        require('@/assets/image/图标4.png'),
        require('@/assets/image/图标5.png'),
        require('@/assets/image/图标6.png')
      ]
    }
  }
}
</script>

<style lang="less">
.footer{
  height: 30%;
  display: flex;
  justify-content: space-around;
  div{
    position: relative;
    z-index: 1;
  }
}
</style> 